import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { ActionResultDTO, ResourceFileDTO } from '../../api/plyca-dtos-v2';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Configuration } from '../../conf/app.constants';
import { Router } from '@angular/router';
import { PaginationDTO } from '../../api/PaginationModel';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';


@Component({
  selector: 'criteriaDefListPanel',
  templateUrl: 'resourceFilesPanel.template.html'
})
export class resourceFilesListPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  resourceFilesList: ResourceFileDTO[] = [];

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected configuration: Configuration,
    public dialogService: DialogService,
    public translate: TranslateService,
    private router: Router
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CONFIGFILES));
  }

  ngAfterContentInit(): void {
    this.headerActionsService.clearActions();

    this.headerActionsService.setTaskDescription(
      this.elem,
      'ControlPanel.resourceFilesList.title',
      'fab fa-readme',
      this.isLoaded.bind(this)
    );

    this.subscribe(this.headerActionsService
      .addAction(
        'General.add',
        'fas fa-plus',
        'btn-primary',
        true
      ),
      () => {
        this.editResourceFile();
      });

    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-secondary', true),
      () => {
        this.loadResourceFilesList();
      });
    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ),
      () => {
        this.uiService.routeBack();
      });

    this.loadResourceFilesList();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadResourceFilesList() {
    this.loaded = false;
    this.subscribe(this.plycaService
      .query<ResourceFileDTO>(this.configuration.RESOURCEFILE_SERVICE_URL),
      (result: PaginationDTO<ResourceFileDTO>) => {
        if (result && result.content) {
          this.resourceFilesList = result.content;
          if (!this.resourceFilesList) {
            this.resourceFilesList = [];
          }
        }
        this.loaded = true;
      });
  }


  editResourceFile(resourceFile?: ResourceFileDTO) {
    this.subscribe(this.plycaService.getAction('IMPORT_RESOURCE_FILE'),
      (datos: any) => {
        if (datos && datos.content) {
          let actionDef = datos.content[0];
          if (actionDef) {
            let action = actionDef.executableAction;

            let config: DynamicDialogConfig = {
              header: action.name,
              width: '60%',
              styleClass: 'actionStyle',
              style: { overflow: 'hidden' }
            };
            config['action'] = action;

            const ref = this.dialogService.open(ActionsProcessComponent, config);
            this.subscribe(ref.onClose, result => {
              this.loadResourceFilesList();
            });

          }
        }
      });
  }

  download(resourceFile?: ResourceFileDTO) {
    let type = 'TYPE=' + resourceFile.fileType.identifier;
    let name = 'NAME=' + resourceFile.name;
    let product = 'PRODUCT=' + resourceFile.product

    this.subscribe(this.plycaService.runActionByName('EXPORT_RESOURCE_FILE', type + '&' + name + '&' + product),
      (result: ActionResultDTO) => {
        if (result) {
          if (result.file) {
            this.subscribe(
              this.plycaService.downloadTmpIvan(result.file),
              () => {
                this.uiService.showSuccess(
                  this.translate.instant('Actions.exec.ok'),
                  this.translate.instant('General.info'),
                  'success'
                );
                console.log('Fichero embedded descargado con exito');
              },
              (err) => {
                let message =
                  this.translate.instant('Actions.exec.error') + ': ' + err;
                this.uiService.showMessage(message, 'Error', 'errorStyle');
              }
            );
          }
        }
      });
  }

}
